// File links can be relative on the main API or absolute on home storage.
// Never concatenate the API origin with an already absolute signed URL.
export function chatMediaUrl(value, base) {
  if (typeof value !== 'string' || !value.trim()) return '';
  try {
    const url = new URL(value, base.replace(/\/$/, '') + '/');
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return '';
    return url.href;
  } catch (_) { return ''; }
}

export function attachmentFromMessage(data, messageId, attachmentId) {
  const messages = Array.isArray(data) ? data : data?.messages;
  const message = (messages || []).find(item => String(item.id) === String(messageId));
  const attachment = (message?.attachments || []).find(item => String(item.id) === String(attachmentId));
  if (!attachment?.url) throw new Error('Файл пока недоступен. Повторите позже или обратитесь к менеджеру.');
  return attachment;
}
